/**
 * Brand color ramps, re-exported from the tokens package.
 *
 * The ramps live in `@primum/tokens` because that package is the source of truth
 * for color on every Primum surface, not just this app. This file stays as the
 * app's import path so call sites do not have to care where it lives, matching
 * how `util/contrast.ts` re-exports the WCAG maths from the same package.
 */

export { BASE_COLORS, DARK_COLORS, LIGHT_COLORS } from '@primum/tokens/colors';
